export default {
  retFlexColumns: state => state.retFlexColumns,
  visibleRetFlexColumns: state => state.retFlexColumns.filter(column => column.visible),
  subventionColumns: state => state.subventionColumns,
  visibleSubventionColumns: state => state.subventionColumns.filter(column => column.visible),
  userRetflexColumns: state => state.userRetFlexColumns

}
